// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"quantity_wrapper__VOrpH","label":"quantity_label__K_O6h","error":"quantity_error___NPO2","buttonContainer":"quantity_buttonContainer__LjBdt"};